import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Button, styled, useMediaQuery, useTheme } from '@mui/material'
import { format } from 'date-fns'
import SnackBarUtils from '../../../../utils/SnackBarUtils'
import '../../../../styles/sortableData.scss'
import { MedioPago } from '../../../../dto/ContractDTO'
import ConfirmDialog from '../../../../pages/Products/components/ConfirmDialog'
import EditarMovimiento from './editarMovimiento'
import { deleteCtaCte } from '../../services/cta.cte.services'
import CardsCtaCte from './CardsCtaCte'
import TableCtaCte from './TableCtaCte'

const ContentTable = styled('div')({
  width: '97%'
})

// const Line = styled.div`
//   width: 97%;
//   border: 1px solid;
//   display: flex;
//   gap: 6px;
//   margin-top: 8px;
//   border-radius: 5px;
// `;

// const Celda = styled.div`
//   /* width: 97%; */
//   /* border: 1px solid; */
// `;

// interface UpIconParams {
//   className?: string;
//   color?: string;
// }

export interface PropsCtaCte {
  getUrl?: string
  handleClose?: any
  show?: boolean
  title?: string
  idLocal: string
  result: any[]
  updateCtaCte: (idLocal) => void
  mediosDePago: MedioPago[]
}

const ModalCtaCte: React.FC<PropsCtaCte> = (props: PropsCtaCte) => {
  const [edit, setEdit] = useState<boolean>(false)
  const [editMovimiento, setEditMovimiento] = useState<any>(null)
  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    text: {
      title: '',
      body: '',
      leftButton: 'Cancelar',
      rightButton: 'Confirmar',
      colorButtonConfirm: 'primary'
    },
    action: async () => {}
  })
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const clearConfirmDialog = () => {
    setConfirmDialog((confirmDialog: any) => ({
      ...confirmDialog,
      open: false
    }))
  }

  const showHideClassName = props.show ? 'modal display-block' : 'modal display-none'

  const closeRenovations = () => {
    // setActions([]);
    props.handleClose()
  }

  const handleDelete = async (idProductoContrato: number, idLocal: number) => {
    setConfirmDialog({
      open: true,
      text: {
        title: '¿Deseas eliminar este movimiento?',
        body: '',
        leftButton: 'Cancelar',
        rightButton: 'Eliminar',
        colorButtonConfirm: 'error'
      },
      action: async () => {
        await deleteCtaCte(idProductoContrato)
          .then((res) => {
            SnackBarUtils.success(res.data.message)
            props.updateCtaCte(idLocal)
          })
          .catch((e) => console.log(e))
          .finally(() => {
            clearConfirmDialog()
          })
      },
      close: () => clearConfirmDialog()
    })
  }

  // const executeAction = (url: string) => {
  //   const idContrato = url
  //     .substring(url.indexOf("contratos"), url.length)
  //     .split("/")[1];
  //   axiosInstanceMain
  //     .get(url)
  //     .then((result) => {
  //       window.alert(result.data);
  //       if (result.status === 200) {
  //         props.setNoShowContracts([
  //           ...props.noShowContracts,
  //           Number.parseInt(idContrato),
  //         ]);
  //       }
  //       closeRenovations();
  //     })
  //     .catch(error => {
  //       console.log(error);
  //     });
  // };

  return (
    <>
      {isMobile ? (
        <CardsCtaCte
          show={props?.show}
          handleClose={props?.handleClose}
          setEdit={setEdit}
          setEditMovimiento={setEditMovimiento}
          result={props?.result}
          onDelete={handleDelete}
          closeRenovations={closeRenovations}
        />
      ) : (
        <div className={showHideClassName}>
          <TableCtaCte
            handleClose={props?.handleClose}
            headers={[
              'ID Contrato',
              'ID Cta Cte',
              'Fecha',
              'Producto',
              'Movimiento',
              'Medio de pago',
              'Comisión',
              'Obs',
              'Acciones'
            ]}
            setEdit={setEdit}
            setEditMovimiento={setEditMovimiento}
            result={props?.result}
            onDelete={handleDelete}
            closeRenovations={closeRenovations}
          />
        </div>
      )}

      {editMovimiento && (
        <EditarMovimiento
          open={edit}
          setOpen={setEdit}
          idMovimiento={editMovimiento.idContratoCuentaCorriente}
          item={editMovimiento}
          setItem={setEditMovimiento}
          mediosDePago={props.mediosDePago}
          updateCtaCte={props.updateCtaCte}
        />
      )}
      <ConfirmDialog {...confirmDialog} />
    </>
  )
}

export default ModalCtaCte
